export default __webpack_public_path__ + "static/media/Globe.e8ba129c.svg";